import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import Tooltipable from "~/components/effects/tooltipable";

export const LabelWithIcon = ({ label, tooltip }) => {
  if (!tooltip) {
    return <>{label}</>;
  }
  const words = label.split(" ");
  const lastWord = words.pop();
  const leadingWords = words.join(" ");
  return (
    <>
      {leadingWords ? `${leadingWords} ` : null}
      <span className="text-nowrap">
        {lastWord}{" "}
        <Tooltipable text={tooltip} trigger="click" placement="right">
          <FontAwesomeIcon
            icon={["fal", "fa-info-circle"]}
            size="sm"
            className="text-secondary"
          />
        </Tooltipable>
      </span>
    </>
  );
};

LabelWithIcon.propTypes = {
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default LabelWithIcon;
